import React from 'react';
import { Route } from 'react-router-dom';

import DenominacoesFicha from '../../ProdutosDAF/DenominacoesGenericas/DenominacoesFicha';
import DenominacoesIndex from '../../ProdutosDAF/DenominacoesGenericas/DenominacoesIndex';
import KitsFicha from '../../ProdutosDAF/Kits/KitsFicha';
import KitsIndex from '../../ProdutosDAF/Kits/KitsIndex';
import PdpFicha from '../../ProdutosDAF/PDP/PdpFicha';
import PdpIndex from '../../ProdutosDAF/PDP/PdpIndex';
import ProdutosDadosGerais from '../../ProdutosDAF/Produtos/ProdutosDadosGerais';
import ProdutosIndex from '../../ProdutosDAF/Produtos/ProdutosIndex';

const ProdutosDAFRoutes = () => {
  return (
    <>
      {/* Produtos Farmacêuticos */}
      <Route path="produtosdaf/produtos" element={<ProdutosIndex />} />
      <Route
        path="produtosdaf/produtos/ficha/dadosgerais"
        element={<ProdutosDadosGerais />}
      />
      <Route
        path="produtosdaf/produtos/ficha/:id/dadosgerais"
        element={<ProdutosDadosGerais />}
      />

      {/* Denominações Genéricas */}
      <Route path="produtosdaf/denominacoes" element={<DenominacoesIndex />} />
      <Route
        path="produtosdaf/denominacoes/ficha/dadosgerais"
        element={<DenominacoesFicha />}
      />
      <Route
        path="produtosdaf/denominacoes/ficha/:id/dadosgerais"
        element={<DenominacoesFicha />}
      />

      {/* Kits de Produtos Farmacêuticos */}
      <Route path="produtosdaf/kits" element={<KitsIndex />} />
      <Route
        path="produtosdaf/kits/ficha/dadosgerais"
        element={<KitsFicha />}
      />
      <Route
        path="produtosdaf/kits/ficha/:id/dadosgerais"
        element={<KitsFicha />}
      />

      {/* PDPs */}
      <Route path="produtosdaf/pdps" element={<PdpIndex />} />
      <Route path="produtosdaf/pdps/ficha/dadosgerais" element={<PdpFicha />} />
      <Route
        path="produtosdaf/pdps/ficha/:id/dadosgerais"
        element={<PdpFicha />}
      />
    </>
  );
};

export default ProdutosDAFRoutes;
